import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";


const UserResultPage = () => {

  const { getResult } = useContext(AdminContext);
  const params = useParams();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);


  useEffect(() => {
    document.title = 'Пользователь'
    getResult(params.user_id, params.category_id, params.test_id).then((res) => {
      if (res.status === 200) {
        document.title = 'Пользователь ' + res.data.u.surname + ' ' + res.data.u.name
        return setResult(res.data)
      }
      else {
        setError(res.data.message);
      }
    });
  }, []);

  return (
    <div className="container">
      <div className="result">
        
        <ButtonBack shortBtn={true} count={2}/>

        {!result && !error ? (
          <CoveredBackground>
            <Loader />
          </CoveredBackground>
        ) : error ? (
          <ErrorMessage message={error} />
        ) : (
          <>
            <div className="result__score">
              {result.result.current_ball}/{result.result.total_ball}
            </div>
            <div className="result__score">
              {(
                (result.result.current_ball / result.result.total_ball) *
                100
              ).toFixed(1)}%
            </div>
            <div className="result__score" style={{ width: 250 }}>
              {result.result.date}
            </div>
            <div className="result__score" style={{ width: 250 }}>
              {result.result.category}
            </div>
            <div className="result__score" style={{ width: 250, fontSize: 20 }}>
              {result.u.name} {result.u.surname}
            </div>
            <div className="result__items">
              {result.result.answers.map((answer, id) => (
                <div
                key={id}
                  className={`result__item ${
                    !answer.r && " result__item__mistake"
                  }`}
                >
                  <div className="result__question">
                    {id + 1}) {answer.q}
                  </div>

                  <div className="result__answer">
                    {answer.a
                      ? `Ответ: ${answer.a}`
                      : `Ответ: Нет ответа`}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserResultPage;
